import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data

/**
 * 自社の請求（買った会社が見る側）。
 *
 * **触れるのは会社の代表者とシステム責任者だけ。**
 * back の ApiAccessPolicyService が /billing を
 * TENANT_OWNER / TENANT_SYSTEM_ADMIN に絞っている。
 *
 * 支払方法は3つ（振込・請求書払い・カード）作ってあるが、
 * **どれを出すかは運営が会社ごとに決める。**決済代行を決めていない
 * のに画面へカード払いが出ると困るため。選べるものは
 * setting() の availableMethods で返る。
 */
export default {
  /** 今月の請求。確定していればその金額、まだなら見込み。 */
  current () {
    return axios.get(origin + '/billing/current').then(responseData)
  },

  /** 過去の請求。既定は12か月ぶん。 */
  history (limit) {
    return axios
      .get(origin + '/billing/history', { params: { limit: limit || 12 } })
      .then(responseData)
  },

  /** いまの支払方法と請求先、そして選べる支払方法。 */
  setting () {
    return axios.get(origin + '/billing/setting').then(responseData)
  },

  /**
   * 支払方法と請求先を保存する。
   *
   * **画面から消しただけでは足りない。**運営が出していない支払方法は
   * サーバ側でも断る。
   */
  saveSetting (form) {
    return axios.post(origin + '/billing/setting', form).then(responseData)
  },

  /**
   * 自社の請求書 PDF（2026-09-22）。
   *
   * **新しいタブで開く。**運営の画面と同じで、ファイル名はサーバの指定
   * （請求書番号.pdf）に任せる。サーバは自社の発行済みの請求しか返さない。
   */
  invoicePdfUrl (billingPeriodId) {
    return origin + '/billing/invoices/pdf'
      + '?billingPeriodId=' + encodeURIComponent(billingPeriodId)
  }
}
